import {css} from 'lit'; export default css`:host{display:block}img{vertical-align:middle}.sds-illustration{max-width:100%;max-height:100%}@media screen and (max-width:600px){.sds-illustration{width:100%;height:100%}}`;
    